export default "__VITE_PUBLIC_ASSET__2aaea666__"